export const PRODUCT_NAME_SEPARATOR = '{productName}';
